"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = exports.Icon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Icon = _styledComponents["default"].div.withConfig({
  displayName: "style__Icon",
  componentId: "sc-2u82n8-0"
})(["dislplay:flex;justify-content:center;width:auto;text-align:center;"]);

exports.Icon = Icon;
var Event = "\n  display: flex;\n";
exports.Event = Event;